// Custom SVG icons for sidebar / panel (CoreUI CIcon format: [viewBox, innerSVG])

const strokeIcon = (paths) => ['24 24', `
  <g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
    ${paths}
  </g>
`]

export const navDashboard = strokeIcon(`
  <path d="M4 13h7V4H4v9zM13 20h7v-9h-7v9zM13 4v6h7V4h-7zM4 20h7v-5H4v5z"/>
`)

export const navMedia = strokeIcon(`
  <rect x="3" y="4" width="18" height="16" rx="2"/>
  <circle cx="9" cy="10" r="1.8"/>
  <path d="M21 16l-5-5-8 9"/>
`)

export const navBlog = strokeIcon(`
  <path d="M5 4h10l4 4v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2z"/>
  <path d="M14 4v4h4M8 12h8M8 16h6"/>
`)

export const navUsers = strokeIcon(`
  <circle cx="12" cy="8" r="3.5"/>
  <path d="M5 19.5c1.5-3.2 4-4.8 7-4.8s5.5 1.6 7 4.8"/>
`)

export const navOrders = strokeIcon(`
  <path d="M7 7h13l-1.5 8H8.5L7 7z"/>
  <path d="M7 7L6 4H3"/>
  <circle cx="9.5" cy="19" r="1.5" fill="currentColor" stroke="none"/>
  <circle cx="17" cy="19" r="1.5" fill="currentColor" stroke="none"/>
`)

export const navProducts = strokeIcon(`
  <path d="M4 8.5l8-4.5 8 4.5v7l-8 4.5-8-4.5v-7z"/>
  <path d="M4 8.5l8 4.5 8-4.5M12 13v7"/>
`)

export const navReports = strokeIcon(`
  <path d="M4 19V5M4 19h16"/>
  <path d="M8 16V10M12 16V7M16 16v-4"/>
`)

export const navDisplay = strokeIcon(`
  <rect x="3" y="4" width="18" height="13" rx="2"/>
  <path d="M8 21h8M12 17v4"/>
`)

export const navPages = strokeIcon(`
  <path d="M7 3h7l5 5v13a1 1 0 01-1 1H7a1 1 0 01-1-1V4a1 1 0 011-1z"/>
  <path d="M14 3v5h5M9 13h6M9 17h4"/>
`)

export const navForms = strokeIcon(`
  <rect x="4" y="3" width="16" height="18" rx="2"/>
  <path d="M8 8h8M8 12h8M8 16h5"/>
`)

export const navSettings = strokeIcon(`
  <circle cx="12" cy="12" r="3"/>
  <path d="M12 3.5v2.2M12 18.3v2.2M4.9 6.5l1.6 1.6M17.5 15.9l1.6 1.6M3.5 12h2.2M18.3 12h2.2M4.9 17.5l1.6-1.6M17.5 8.1l1.6-1.6"/>
`)

export const navEye = strokeIcon(`
  <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/>
  <circle cx="12" cy="12" r="3"/>
`)

export const iconSun = strokeIcon(`
  <circle cx="12" cy="12" r="4"/>
  <path d="M12 2.5v2.2M12 19.3v2.2M4.2 4.2l1.6 1.6M18.2 18.2l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.2 19.8l1.6-1.6M18.2 5.8l1.6-1.6"/>
`)

export const iconMoon = strokeIcon(`
  <path d="M20 14.5A7.5 7.5 0 019.5 4 7.5 7.5 0 1019.5 16.5c.17-.65.25-1.32.25-2z"/>
`)

export const iconBell = strokeIcon(`
  <path d="M6 16h12l-1.2-1.5a4.2 4.2 0 01-.8-2.5V9.5a5 5 0 00-10 0v2.5c0 .9-.28 1.78-.8 2.5L6 16z"/>
  <path d="M10 18a2 2 0 004 0"/>
`)

export const iconMenu = strokeIcon(`
  <path d="M4 7h16M4 12h16M4 17h16"/>
`)

export const iconClose = strokeIcon(`
  <path d="M6 6l12 12M18 6L6 18"/>
`)

export const iconList = strokeIcon(`
  <path d="M8 7h12M8 12h12M8 17h12M4 7h.01M4 12h.01M4 17h.01"/>
`)

export const iconComment = strokeIcon(`
  <path d="M4 6.5A2.5 2.5 0 016.5 4h11A2.5 2.5 0 0120 6.5v7a2.5 2.5 0 01-2.5 2.5H10l-4 3.5V16H6.5A2.5 2.5 0 014 13.5v-7z"/>
`)

export const iconEdit = strokeIcon(`
  <path d="M4 20h4l10.5-10.5a2.1 2.1 0 00-3-3L5 17v3z"/>
  <path d="M13.5 6.5l3 3"/>
`)

export const iconClone = strokeIcon(`
  <rect x="8" y="8" width="12" height="12" rx="2"/>
  <path d="M16 8V6a2 2 0 00-2-2H6a2 2 0 00-2 2v8a2 2 0 002 2h2"/>
`)

export const iconTrash = strokeIcon(`
  <path d="M4 7h16M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2M8 7l1 12a1 1 0 001 1h4a1 1 0 001-1l1-12"/>
`)

export const iconEyeOff = strokeIcon(`
  <path d="M3 3l18 18"/>
  <path d="M10.6 10.6a2 2 0 002.8 2.8"/>
  <path d="M9.9 5.2A10.4 10.4 0 0112 5c6.5 0 10 7 10 7a17.3 17.3 0 01-4.1 4.6M6.1 6.1A17.5 17.5 0 002 12s3.5 7 10 7a10.2 10.2 0 004.1-.8"/>
`)

export const iconDollar = strokeIcon(`
  <path d="M12 3v18M16 8.5c0-1.7-1.8-3-4-3s-4 1.3-4 3 1.8 3 4 3 4 1.3 4 3-1.8 3-4 3-4-1.3-4-3"/>
`)

export const iconCheck = strokeIcon(`
  <path d="M5 12.5l4.5 4.5L19 7"/>
`)

export const iconStar = strokeIcon(`
  <path d="M12 3l2.2 6.6H21l-5.4 3.9 2.1 6.5L12 16.8 6.3 20l2.1-6.5L3 9.6h6.8L12 3z"/>
`)

export const iconStarFill = ['24 24', `
  <path fill="currentColor" d="M12 3l2.2 6.6H21l-5.4 3.9 2.1 6.5L12 16.8 6.3 20l2.1-6.5L3 9.6h6.8L12 3z"/>
`]

export const iconPlus = strokeIcon(`
  <path d="M12 5v14M5 12h14"/>
`)

export const iconDownload = strokeIcon(`
  <path d="M12 4v11M8 11l4 4 4-4M5 19h14"/>
`)

export const iconUpload = strokeIcon(`
  <path d="M12 20V9M8 13l4-4 4 4M5 5h14"/>
`)

export const iconChevronLeft = strokeIcon(`
  <path d="M14 6l-6 6 6 6"/>
`)

export const iconChevronRight = strokeIcon(`
  <path d="M10 6l6 6-6 6"/>
`)

export const iconSearch = strokeIcon(`
  <circle cx="11" cy="11" r="7"/>
  <path d="M20 20l-3.5-3.5"/>
`)

export const iconUser = strokeIcon(`
  <circle cx="12" cy="8" r="4"/>
  <path d="M4 21c1.6-4 4.5-6 8-6s6.4 2 8 6"/>
`)

export const iconLogout = strokeIcon(`
  <path d="M15 4h3a2 2 0 012 2v12a2 2 0 01-2 2h-3"/>
  <path d="M10 17l-5-5 5-5M5 12h11"/>
`)

export const iconChevronDown = strokeIcon(`
  <path d="M6 9l6 6 6-6"/>
`)

export const iconSidebar = strokeIcon(`
  <rect x="3" y="4" width="18" height="16" rx="2"/>
  <path d="M15 4v16"/>
`)

export const iconExternal = strokeIcon(`
  <path d="M14 4h6v6M20 4l-9 9"/>
  <path d="M18 14v4a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2h4"/>
`)

export const iconRefresh = strokeIcon(`
  <path d="M20 11a8 8 0 00-14.3-4.9L4 8M4 4v4h4"/>
  <path d="M4 13a8 8 0 0014.3 4.9L20 16M20 20v-4h-4"/>
`)